import controller from './product-not-found.controller';
import template from './product-not-found.view.html';

let ProductNotFoundComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ProductNotFoundComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/product-not-found/product-not-found.component.js
 **/